import React, { useMemo } from 'react'
import { Col } from 'react-bootstrap'
import { useQuery } from '@apollo/client'
import Loader from 'components/ui/loader/Loader'

import { AREA, QueryAreaArgs, TDataArea } from 'graphqlAPI'

import { ChildFilterTypes } from 'enum'
import { ApplyFiltersByType } from '../types'
import { GeneralProgress } from './GeneralProgress'

interface AreaProgressProps {
  areaId: string | number
  applyFiltersByType: ApplyFiltersByType
}

export const AreaProgress: React.FC<AreaProgressProps> = ({
  areaId,
  applyFiltersByType,
}) => {
  const g = useMemo(
    () => applyFiltersByType(ChildFilterTypes.Area),
    [applyFiltersByType]
  )

  const areaQuery = useQuery<TDataArea, QueryAreaArgs>(AREA, {
    variables: {
      id: areaId.toString(),
      q: {
        g: g.filters,
      },
    },
    fetchPolicy: 'cache-and-network',
  })

  const area = areaQuery.data?.area
  const { coursesProgress = [] } = { ...area }

  if (areaQuery.loading) {
    return (
      <Col>
        <div className="d-flex justify-content-center">
          <Loader color />
        </div>
      </Col>
    )
  }

  if (!area) return null

  const { participantsCount, coursesCount } = area

  return (
    <GeneralProgress
      data={
        area
          ? {
              coursesProgress,
              participantsCount,
              coursesCount,
            }
          : undefined
      }
      loading={areaQuery.loading}
    />
  )
}
